var _circle, _path, _path2, _circle2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.3073,
    cy: 42.2429,
    r: 24.1919,
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.4226 38.3206L50.5766 42.2436L58.4226 46.1666",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1916 38.3206L44.0376 42.2436L36.1916 46.1666",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.3065,
    cy: 42.2428,
    r: 17.6535,
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0072 62.8104L65.9495 68.7527M65.4192 57.3984L71.3615 63.3407",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5899 71.228C62.6372 69.2754 62.6372 66.1096 64.5899 64.157L66.7654 61.9814C68.718 60.0288 71.8839 60.0288 73.8365 61.9814L83.9261 72.071C85.8787 74.0237 85.8787 77.1895 83.9261 79.1421L81.7506 81.3177C79.7979 83.2703 76.6321 83.2703 74.6795 81.3177L64.5899 71.228Z",
    fill: "#8999A4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4323 16.955C72.9667 16.2274 73.9898 16.0709 74.7173 16.6054V16.6054C75.4449 17.1399 75.6014 18.1629 75.0669 18.8905L71.8582 23.2583C71.3237 23.9859 70.3006 24.1424 69.5731 23.6079V23.6079C68.8455 23.0734 68.689 22.0504 69.2235 21.3228L72.4323 16.955Z",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7258 25.292C80.5858 25.0175 81.5055 25.4922 81.7799 26.3523V26.3523C82.0544 27.2123 81.5796 28.132 80.7196 28.4064L75.5563 30.054C74.6963 30.3285 73.7766 29.8537 73.5022 28.9937V28.9937C73.2277 28.1337 73.7024 27.214 74.5625 26.9396L79.7258 25.292Z",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.574 58.0848C14.7072 58.3374 14.2094 59.2447 14.4619 60.1114V60.1114C14.7145 60.9781 15.6218 61.476 16.4886 61.2234L21.692 59.7072C22.5587 59.4546 23.0565 58.5473 22.804 57.6806V57.6806C22.5514 56.8138 21.6441 56.316 20.7774 56.5685L15.574 58.0848Z",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.905 67.7951C20.3523 68.5088 20.4829 69.5355 21.1966 70.0883V70.0883C21.9104 70.641 22.9371 70.5105 23.4898 69.7967L26.8082 65.5115C27.3609 64.7978 27.2304 63.7711 26.5166 63.2183V63.2183C25.8029 62.6656 24.7762 62.7961 24.2234 63.5099L20.905 67.7951Z",
    stroke: "#8999A4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearch);
export default __webpack_public_path__ + "static/media/no-search.d1fb7ddd7673df6349e687fd382ddf1b.svg";
export { ForwardRef as ReactComponent };